/**
 * Very basic pluralisation function
 * @param singularWord the single version of the word
 * @param number the number associated with this word
 * @param pluralWord the plural overwrite version
 * @returns the word, pluralised if necessary
 */
export const pluralise = (
  singularWord: string,
  number: number,
  config?: {
    pluralWord?: string;
    skipNumber?: boolean;
  },
): string => {
  const result: string[] = [];

  if (!config?.skipNumber) {
    result.push(`${number}`);
  }

  if (number === 1) {
    result.push(singularWord);
  } else if (config?.pluralWord) {
    result.push(config.pluralWord);
  } else {
    result.push(`${singularWord}s`);
  }

  return result.join(' ');
};
